import { useSelector } from "react-redux";
import { fetchPackageDetails } from "../utils/services";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";

const useFetchPackageDetails = () => {
    const [packageDetails, setPackageDetails] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const culture = useSelector((state) => state.culture.currentCulture);
    const currency = useSelector((state) => state.currencyDetails);
    const location = useLocation();

    const packageKey = new URLSearchParams(location.search).get("packagekey");

    const fetchDetails = useCallback(async () => {
        if (currency.loading || !packageKey) return;

        try {
            setLoading(true);
            const packageDetails = await fetchPackageDetails(
                culture,
                currency.currentCurrency,
                packageKey
            );
            if (packageDetails) {
                setPackageDetails(packageDetails);
            }
        } catch (error) {
            console.error("Error fetching package details:", error);
        } finally {
            setLoading(false);
        }
    }, [culture, currency, packageKey]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    return { packageDetails, isLoading, packageKey };
};

export default useFetchPackageDetails;
